import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppSharedModule } from "../../shared/app-shared.module";

import { ConfirmationService } from "primeng/api";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DynamicDialogModule } from "primeng/dynamicdialog";
import { CalendarModule } from "primeng/calendar";
import { DialogModule } from "primeng/dialog";
import { TreeModule } from "primeng/tree";
import { TableModule } from "primeng/table";
import { ButtonModule } from "primeng/button";
import { MultiSelectModule } from "primeng/multiselect";
import { DropdownModule } from "primeng/dropdown";
import { InputNumberModule } from "primeng/inputnumber";
import { RadioButtonModule } from "primeng/radiobutton";
import { InputTextareaModule } from "primeng/inputtextarea";
import { TreeTableModule } from "primeng/treetable";
import { ListboxModule } from "primeng/listbox";

import { SysAdminService } from "./services/sysadmin.service";
import { SysAdminComponent } from "./components/sysadmin.component";

import { MTACardManagerComponent } from "./mtacardmanager/mtacardmanager.component";
import { MTAStatusComponent } from "./mtacardmanager/mtastatus/mtastatus.component";
import { DataService_mtacardmanager } from "./mtacardmanager/shared/data.service";

//User Admin
import { UserAdministrationComponent } from "./user-administration/user-administration.component";
import { UserDetailsComponent } from "./user-administration/shared/user-details/user-details.component";
import { UserGroupsComponent } from "./user-administration/shared/user-groups/user-groups.component";
import { SchoolsComponent } from "./user-administration/shared/schools/schools.component";
import { AddUserRolesComponent } from "./user-administration/shared/roles/roles.component";
import { EmailMessagingComponent } from "./user-administration/shared/email-messaging/email-messaging.component";
import { AddUserGroupComponent } from "./user-administration/shared/user-groups/add-user-group/add-user-group.component";
import { AddSchoolComponent } from "./user-administration/shared/schools/add-school/add-school.component";
import { AddRolesComponent } from "./user-administration/shared/roles/add-roles/add-roles.component";

//User Group Admin
import { UserGroupAdministrationComponent } from "./user-group-administration/user-group-administration.component";
import { UserGroupTableComponent } from "./user-group-administration/user-group-table/user-group-table.component";
import { UserGroupRoleTableComponent } from "./user-group-administration/user-group-role-table/user-group-role-table.component";
import { UserGroupUserTableComponent } from "./user-group-administration/user-group-user-table/user-group-user-table.component";
import { UserGroupEditUserGroupComponent } from "./user-group-administration/user-group-table/edit-user-group/edit-user-group.component";
import { UserGroupAddUserGroupComponent } from "./user-group-administration/user-group-table/add-user-group/add-user-group.component";
import { UserGroupAddRolesComponent } from "./user-group-administration/user-group-role-table/user-group-add-roles/user-group-add-roles.component";
import { UserGroupAddUsersComponent } from "./user-group-administration/user-group-user-table/user-group-add-users/user-group-add-users.component";

//User Group Assign
import { UserGroupAssignmentComponent } from "./user-group-assignment/user-group-assignment.component";
import { UserGroupAssignContainerComponent } from "./user-group-assignment/user-group-assign-container/user-group-assign-container.component";
import { UserGroupAssignSchoolComponent } from "./user-group-assignment/user-group-assign-school/user-group-assign-school.component";
import { UserGroupAddContainerComponent } from "./user-group-assignment/user-group-assign-container/user-group-add-container/user-group-add-container.component";
import { UserGroupAddSchoolComponent } from "./user-group-assignment/user-group-assign-school/user-group-add-school/user-group-add-school.component";

//School Container (New Version)
import { ManageSchoolContainerComponent } from "./manage-school-container/manage-school-container.component";
import { ManageSchoolContainerTableComponent } from "./manage-school-container/manage-school-container-table/manage-school-container-table.component";
import { ManageSchoolContainerSchoolTableComponent } from "./manage-school-container/manage-school-container-school-table/manage-school-container-school-table.component";
import { ManageSchoolContainerUserTableComponent } from "./manage-school-container/manage-school-container-user-table/manage-school-container-user-table.component";
import { ManageSCTAddComponent } from "./manage-school-container/manage-school-container-table/manage-sctadd/manage-sctadd.component";
import { ManageSCTEditComponent } from "./manage-school-container/manage-school-container-table/manage-sctedit/manage-sctedit.component";
import { MSCAddSchoolComponent } from "./manage-school-container/manage-school-container-school-table/mscadd-school/mscadd-school.component";
import { MSCAddUserGroupComponent } from "./manage-school-container/manage-school-container-user-table/mscadd-user-group/mscadd-user-group.component";

//Role Administration
import { ManageRolesComponent } from "./manage-roles/manage-roles.component";
import { RoleAdminAddRoleComponent } from "./manage-roles/role-admin-add-role/role-admin-add-role.component";
import { ManageApplicationItemsComponent } from "./manage-roles/role-admin-add-role/manage-application-items/manage-application-items.component";
import { ManageReportsComponent } from "./manage-roles/role-admin-add-role/manage-reports/manage-reports.component";
import { RoleAdminEditRoleComponent } from "./manage-roles/role-admin-edit-role/role-admin-edit-role.component";
import { RoleAdminCopyRoleComponent } from "./manage-roles/role-admin-copy-role/role-admin-copy-role.component";
import { SchoolselectorModule } from "../schoolselector/schoolselector.module";
import { UserModifyComponent } from "./user-administration/user-modify/user-modify.component";
import { UserModifyDetailsComponent } from "./user-administration/user-modify/user-modify-details/user-modify-details.component";
import { UserModifySchoolsComponent } from "./user-administration/user-modify/user-modify-schools/user-modify-schools.component";
import { UserModifyRolesComponent } from "./user-administration/user-modify/user-modify-roles/user-modify-roles.component";
import { UserModifyUserGroupsComponent } from "./user-administration/user-modify/user-modify-user-groups/user-modify-user-groups.component";
import { UserModifyEmailComponent } from "./user-administration/user-modify/user-modify-email/user-modify-email.component";
import { UserModifyAddSchoolComponent } from "./user-administration/user-modify/user-modify-schools/user-modify-add-school/user-modify-add-school.component";
import { UserModifyAddRolesComponent } from "./user-administration/user-modify/user-modify-roles/user-modify-add-roles/user-modify-add-roles.component";
import { UserModifyAddUserGroupsComponent } from "./user-administration/user-modify/user-modify-user-groups/user-modify-add-user-groups/user-modify-add-user-groups.component";
import { PasswordResetEmailComponent } from "./user-administration/password-reset-email/password-reset-email.component";
import { UserAdminAddStaffComponent } from "./user-administration/user-modify/user-modify-details/user-admin-add-staff/user-admin-add-staff.component";
import { MfaToggleComponent } from "./user-administration/mfa-toggle/mfa-toggle.component";
import { CustomTooltipModule } from "../../shared/custom-tool-tip/custom-tool-tip.component";
import { RoleAdminSUComponent } from "./role-admin-su/role-admin-su.component";
import { DataService_RoleAdminSU } from "./role-admin-su/shared/data.service";
import { RoleSuSchoolMaintenanceComponent } from "./role-admin-su/role-su-school-maintenance/role-su-school-maintenance.component";
import { RoleSuDistrictUsersComponent } from "./role-admin-su/role-su-district-users/role-su-district-users.component";
import { RoleSuUserByRoleComponent } from "./role-admin-su/role-su-user-by-role/role-su-user-by-role.component";
import { RoleSuUserMultipleSchoolsComponent } from "./role-admin-su/role-su-user-multiple-schools/role-su-user-multiple-schools.component";
import { RoleSuUserInactiveStaffComponent } from "./role-admin-su/role-su-user-inactive-staff/role-su-user-inactive-staff.component";
import { RoleSuRoleAddUsersComponent } from "./role-admin-su/shared/role-su-role-add-users/role-su-role-add-users.component";
import { RoleSuSchoolOrDistrictComponent } from "./role-admin-su/shared/role-su-school-or-district/role-su-school-or-district.component";
import { RoleSuDistrictUserOptionComponent } from "./role-admin-su/role-su-district-users/role-su-district-user-option/role-su-district-user-option.component";
import { RoleSuUserNoRolesComponent } from "./role-admin-su/role-su-user-no-roles/role-su-user-no-roles.component";
import { RoleAdminSuReactivateStaffOptionsComponent } from "./role-admin-su/role-su-user-inactive-staff/role-admin-su-reactivate-staff-options/role-admin-su-reactivate-staff-options.component";
import { RoleAdminSuNoRolesAddRolesComponent } from "./role-admin-su/role-su-user-no-roles/role-admin-su-no-roles-add-roles/role-admin-su-no-roles-add-roles.component";
import { SSOMaintenanceComponent } from "./sso-maintenance/sso-maintenance.component";
import { IdentityProviderTableComponent } from "./sso-maintenance/identity-provider-table/identity-provider-table.component";
import { ModifyIDPComponent } from "./sso-maintenance/identity-provider-table/modify-idp/modify-idp.component";
import { DataService_SSO } from "./sso-maintenance/shared/data.service";
import { ColorPickerModule } from "primeng/colorpicker";

@NgModule({
	declarations: [
		SysAdminComponent,
		MTACardManagerComponent,
		MTAStatusComponent,
		UserAdministrationComponent,
		UserDetailsComponent,
		UserGroupsComponent,
		SchoolsComponent,
		AddUserRolesComponent,
		EmailMessagingComponent,
		AddUserGroupComponent,
		AddSchoolComponent,
		AddRolesComponent,
		UserGroupAdministrationComponent,
		UserGroupTableComponent,
		UserGroupRoleTableComponent,
		UserGroupUserTableComponent,
		UserGroupAddUserGroupComponent,
		UserGroupEditUserGroupComponent,
		UserGroupAddRolesComponent,
		UserGroupAddUsersComponent,
		UserGroupAssignmentComponent,
		UserGroupAssignContainerComponent,
		UserGroupAssignSchoolComponent,
		UserGroupAddContainerComponent,
		UserGroupAddSchoolComponent,
		ManageSchoolContainerComponent,
		ManageSchoolContainerTableComponent,
		ManageSchoolContainerSchoolTableComponent,
		ManageSchoolContainerUserTableComponent,
		ManageSCTAddComponent,
		ManageSCTEditComponent,
		MSCAddSchoolComponent,
		MSCAddUserGroupComponent,
		ManageRolesComponent,
		RoleAdminAddRoleComponent,
		ManageApplicationItemsComponent,
		ManageReportsComponent,
		RoleAdminEditRoleComponent,
		RoleAdminCopyRoleComponent,
		UserModifyComponent,
		UserModifyDetailsComponent,
		UserModifySchoolsComponent,
		UserModifyRolesComponent,
		UserModifyUserGroupsComponent,
		UserModifyEmailComponent,
		UserModifyAddSchoolComponent,
		UserModifyAddRolesComponent,
		UserModifyAddUserGroupsComponent,
		PasswordResetEmailComponent,
		UserAdminAddStaffComponent,
		MfaToggleComponent,
		RoleAdminSUComponent,
		RoleSuSchoolMaintenanceComponent,
		RoleSuDistrictUsersComponent,
		RoleSuUserByRoleComponent,
		RoleSuUserMultipleSchoolsComponent,
		RoleSuUserInactiveStaffComponent,
		RoleSuRoleAddUsersComponent,
		RoleSuSchoolOrDistrictComponent,
		RoleSuDistrictUserOptionComponent,
		RoleSuUserNoRolesComponent,
		RoleAdminSuReactivateStaffOptionsComponent,
		RoleAdminSuNoRolesAddRolesComponent,
		SSOMaintenanceComponent,
		IdentityProviderTableComponent,
		ModifyIDPComponent,
	],

	imports: [
		CommonModule,
		FormsModule,
		AppSharedModule,
		RouterModule,
		BrowserAnimationsModule,
		ConfirmDialogModule,
		DynamicDialogModule,
		CalendarModule,
		DialogModule,
		TreeModule,
		TableModule,
		ButtonModule,
		MultiSelectModule,
		DropdownModule,
		InputNumberModule,
		RadioButtonModule,
		InputTextareaModule,
		TreeTableModule,
		ListboxModule,
		SchoolselectorModule,
		CustomTooltipModule,
		ColorPickerModule,
	],

	providers: [ConfirmationService, SysAdminService, DataService_mtacardmanager, DataService_RoleAdminSU, DataService_SSO],
})
export class SysAdminModule {}
